import FileUploadInput from '../file-upload-input/file-upload-input';
import './file-upload-multiple.scss';
import template from './file-upload-multiple.vhtml';

export default {
	template,
	props: {
		accept: {
			type: String,
			default: '',
		},
		inputName: {
			type: String,
			default: 'files[]',
		},
		translateStrings: {
			type: Object,
			default: () => ({
				addFile: 'Tilføj fil',
				remove:  'Fjern',
			}),
		},
		value: {
			type: Array,
		},
	},
	data: () => ({
		currentFileKey: 0,
		files: [{
			uploaded: false,
			key: 0,
		}],
	}),
	methods: {
		getNextFileKey() {
			this.currentFileKey = this.currentFileKey + 1;
			return this.currentFileKey;
		},
		onFileChanged( changedFile ) {
			this.files = this.files
				.map( file => file.key === changedFile.key ? Object.assign({}, file, { uploaded: true }) : file );

			if ( this.files.filter( file => !file.uploaded ).length === 0 ) {
				this.files = [ ...this.files, { uploaded: false, key: this.getNextFileKey() }];
			}

			this.emitUpdated();
		},
		onFileRemoved( removedFile ) {
			this.files = this.files
				.filter( file => file.key !== removedFile.key );

			if ( this.files.length === 0 ) {
				this.files = [{
					uploaded: false,
					key: this.getNextFileKey(),
				}];
			}

			this.emitUpdated();
		},
		emitUpdated() {
			this.$emit( 'input', this.files.filter( file => file.uploaded ) );
		},
	},
	components: {
		FileUploadInput,
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/file-upload-multiple/file-upload-multiple.js